import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import CpfRatioBox from 'components/pages/Report/ReportDiet/CpfRatioBox';
import HBox from 'components/common/HBox';

export default function ExerciseDialogDietTable(props) {
  const {
    data,
    ...rest
  } = props;

  const {
    bldsugr_graph_list = [],
    // bld_sugr_time,
    // bld_sugr_value,
    step_cnt_graph_list = [],
    // active_time,
    // step_cnt,
    daily_step_cnt,
    daily_step_time,
    postprand2h_step_cnt,
    postprand2h_step_time,
    daily_burn_cal,
    postprand2h_burn_cal,
    max_bldsugr_val,
    max_bldsugr_time,
    max_bldsugr_tmzone_cd,
    min_bldsugr_val,
    min_bldsugr_time,
    min_bldsugr_tmzone_cd,
    max_bldsugr_rise_w,
    avg_bldsugr,
    postprand2h_bldsugr_val,
    total_abnormal_cnt,
    total_high_cnt,
    total_low_cnt,
    avg_intaken_cal,
    total_intaken_cal,
    carbo_rate,
    protein_rate,
    fat_rate,
    total_insulin_amt,
    total_bolus_amt,
    total_giju_amt,
    bolus_inject_list = [],
    // bolus_inject_time,
    // bolus_inject_amt,
  } = data;

  return (
    <table>
      <tbody>
        <tr>
          <th>
            <div>
              {T('총 섭취칼로리')}
            </div>
          </th>
          <td>
            <div>
              {T('{0} kcal', total_intaken_cal)}
            </div>
          </td>
        </tr>
        <tr>
          <th>
            <div>
              {T('탄단지 비율')}
            </div>
          </th>
          <td>
            <HBox center vcenter>
              {T('{0}-{1}-{2} g', carbo_rate, protein_rate, fat_rate)}
            </HBox>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
